// client/src/components/Login.js
import React, { useState } from 'react';
import axios from 'axios';
import { Form, Button } from 'react-bootstrap';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext'; // Import useAuth

const Login = () => {
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [redirect, setRedirect] = useState(false);
  const [error, setError] = useState('');
  const { login: authLogin } = useAuth(); // Get the login function from context

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const response = await axios.post('/auth/login', { login, password });
      authLogin(response.data.token); // Tell the whole app the user is logged in!
      setRedirect(true);
    } catch (error) {
      console.error(error);
      const backendError = error.response?.data?.error || 'Login failed. Please try again.';
      setError(backendError);
    }
  };

  if (redirect) {
    return <Navigate to="/" />;
  }

  return (
    <Form onSubmit={handleSubmit}>
      {error && <div className="alert alert-danger">{error}</div>}
      <Form.Group controlId="formLogin" className="mb-3">
        <Form.Label>Login</Form.Label>
        <Form.Control type="text" value={login} onChange={(e) => setLogin(e.target.value)} required />
      </Form.Group>
      <Form.Group controlId="formPassword" className="mb-3">
        <Form.Label>Password</Form.Label>
        <Form.Control type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
      </Form.Group>
      <Button variant="primary" type="submit">Login</Button>
    </Form>
  );
};

export default Login;